import { ProjectAvatar } from '@components/ArtBoard/Header/components/ProjectMenu/components'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  avatar: string | null
  onOpen?: () => void
}

export const ProjectMenuButton = forwardRef<HTMLButtonElement, Props>(
  ({ avatar, onOpen = () => {} }, ref) => {
    const { active, toggle } = DropdownMenu.useTrigger()
    const onPointerDown = () => {
      if (!active) {
        onOpen()
      }
      toggle()
    }
    const className = clsJoin(css.project_menu_button, active && css.active)
    return (
      <button onPointerDown={onPointerDown} ref={ref} className={className}>
        <ProjectAvatar avatar={avatar} />
        <div className={css.dropdown_button_icon}>
          <AngleDown className={css.dropdown_icon} />
        </div>
      </button>
    )
  }
)
